import React from 'react';

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rotate: 0,
    };
  }

  render() {
    const { rotate } = this.state;

    const rotateImage = () => {
      if (!this.props.canRotate) return;

      const r = rotate !== 270 ? rotate + 90 : 0;

      this.setState({
        rotate: r,
      });
    };

    return (
      <img
        src={this.props.src}
        ref={(elm) => {
          this.image = elm;
        }}
        alt=""
        onClick={rotateImage}
        className={`img-fluid img-thumbnail rotate-${this.state.rotate}`}
      />
    );
  }
}

export default Image;
